import { render, staticRenderFns } from "./StatusTab.vue?vue&type=template&id=34af07dc&scoped=true"
import script from "./StatusTab.vue?vue&type=script&lang=js"
export * from "./StatusTab.vue?vue&type=script&lang=js"
import style0 from "./StatusTab.vue?vue&type=style&index=0&id=34af07dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34af07dc",
  null
  
)

export default component.exports